export default "__VITE_ASSET__B26vd1aH__"